import { Connector } from "wagmi";
import { createKeyStoreInteractor, createWeb3ProviderEvmKeyStore } from "@chromia/ft4";
import { IClient } from "postchain-client";

import { getGtxClient } from "./getGtxClient";
import { store } from "../../store/store";
import { eChromiaActionTypes } from "../../store/chromia/chromiaTypes";


export const connect = async (connector: Connector) => {
	const provider = await (connector?.options?.getProvider? connector?.options?.getProvider() : connector?.getProvider());
		
	const gtx = await getGtxClient();

	if (!provider) throw new Error('missing provider');

	const interactor = await createWeb3ProviderEvmKeyStore(provider).then((keyStore) => { return createKeyStoreInteractor(gtx as IClient, keyStore) })
	// console.log('interactor: ', interactor);
	const accs = await interactor.getAccounts();
	// console.log('accs: ', accs);
	if (!accs[0]){
		store.dispatch({
			type: eChromiaActionTypes.SET_IS_CHR_REGISTERED,
			payload: false
		})
		return;
	}
	const session = await interactor.getSession(accs[0].id);
	// console.log('session: ', session);
	store.dispatch({
		type: eChromiaActionTypes.SET_CHR_CLIENT_ADDR,
		payload: accs[0].id.toString('hex')
	});
	store.dispatch({
		type: eChromiaActionTypes.SET_SESSION,
		payload: session
	});
	store.dispatch({
		type: eChromiaActionTypes.SET_IS_CHR_REGISTERED,
		payload: true
	});
	// getData();
}